<div #fichaPDF></div>